import type { ComponentPropsWithoutRef } from "react"
import { useMemo } from "react"

import { useSliderContext } from "./SliderContext"
import { SliderTrack } from "./SliderTrack"

export interface Props extends ComponentPropsWithoutRef<"div"> {
  min: number;
  max: number;
}

/*
 * this element fills in the space between two values within a Slider
 */
export function SliderTracks(props: Props) {
  const {
    min,
    max,
    ...htmlDivProps
  } = props

  const { inputValues } = useSliderContext()

  const valueRanges : Array<[number, number]> = useMemo(
    () => {
      const values = [
        min,
        ...inputValues,
        max,
      ]

      const ranges: Array<[number, number]> = []

      values.forEach(
        (number, index) => {
          if (index === 0) {
            return
          }

          ranges.push([
            values[index - 1],
            number,
          ])
        },
      )

      return ranges
    },
    [
      min,
      max,
      inputValues,
    ],
  )

  const highlightSegments = valueRanges.length % 2 === 1 ? 1 : 0

  return (
    <>
      {
        valueRanges.map(
          (
            rangeValues,
            index,
          ) => {
            const highlight = (index % 2) === highlightSegments

            return (
              <SliderTrack
                {...htmlDivProps}
                key={`${highlight ? "highlight" : "track"}-${index}`}
                min={min}
                max={max}
                lowValue={rangeValues[0]}
                highValue={rangeValues[1]}
                highlight={highlight}
              />
            )
          },
        )
      }
    </>
  )
}
